export default "__VITE_ASSET__Dhz5TyQQ__"